import {computed, onMounted, ref, useTranslation} from '#imports';
import {getPageCountryCode} from '@malt/dom';

export function useRemoteLabels() {
    const {t} = useTranslation();
    const countryCode = ref<string | undefined>('');

    onMounted(() => {
        countryCode.value = getPageCountryCode();
    });

    const remoteCountryLabel = computed(() => (countryCode.value ? t(`search.location.remote.${countryCode.value}` as any) : undefined));

    return {
        remoteCountryLabel,
    };
}
